import AppShell from "@/components/shell/AppShell";

const AdminLayout = () => <AppShell />;

export default AdminLayout;
